import GA4 from 'react-ga4';
import GA from 'react-ga';
import { ITemplate } from 'types/dto';
import * as gtm from 'utils/google/gtm';
import { config } from './config';

const isGA4Enabled = isGA4(config.ga);
const gaInstance = isGA4Enabled ? GA4 : GA;

const PAGE_VIEW_DEBOUNCE_DELAY = 300;

let pageViewTimer: ReturnType<typeof setTimeout>;

export interface IPageViewOptions {
  page?: string;
  title?: string;
}

export function ga() {
  return gaInstance;
}

export function init() {
  gtm.initialize(config.gtm);
  ga().initialize(config.ga);
}

export function pageView(options: IPageViewOptions = {}) {
  clearTimeout(pageViewTimer);
  pageViewTimer = setTimeout(() => {
    const location = window.location.pathname + window.location.search;
    const title = window.document.title;

    if (isGA4Enabled) {
      ga().send({
        hitType: 'pageview',
        page_title: title,
        page_location: location,
        ...options,
      });
    } else {
      // @ts-ignore
      ga().pageview(location, [], title);
    }
  }, PAGE_VIEW_DEBOUNCE_DELAY);
}

export function downloadTemplate(template: ITemplate) {
  const event = 'Download Template';
  const detail = `${template.code}, ${template.name}`;

  ga().event({
    category: 'Downloads',
    action: event,
    label: detail,
  });
  gtm.getDataLayer().push({
    event,
    detail,
  });
}

function isGA4(gaId: string): boolean {
  return gaId.startsWith('G-');
}
